<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="documentName"
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">
         <template #col-request_date="{ row }">
            {{ renderDate(row.request_date) }}
        </template>
        <template #col-statusName="{ row }">
            <vs-chip :color="row.statusColor">
                {{ $t(row.statusName) | capitalize }}
            </vs-chip>
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'
import { renderDate } from '@/utils/helpers'

const emit = defineEmits(['sortChanged', 'loadMore'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'VendorName', label: 'vendor', sortable: false },
    { key: 'documentName', label: 'document', sortable: false },
    { key: 'clientName', label: 'client', sortable: false },
    { key: 'userName', label: 'user', sortable: false },
    { key: 'request_date', label: 'date', sortable: false },
    { key: 'statusName', label: 'status', sortable: false }
    
])

const actionButtons = ref([])


</script>
